import { analytics } from '@infakt/analytics';

const meta = document.querySelector('meta[name="analytics-config"]');

if (meta) {
  const { user_id: userId, ...env } = JSON.parse(meta.content);

  analytics.init(env, { app: 'infakt', bootstrap: { user_id: userId } });
}
